export interface CVAddModel {
  open_link_id?: string | null;
  vacancy_id?: string | null;
  invitation_id?: string | null;
  source?: string | null;
}
